var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3",style:(("width: " + (_vm.element.config.width || 100) + "%"))},[_c('div',{style:(_vm.lineStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }